import * as React from 'react';
import clsx from 'clsx';
import Widget from '../Widget';
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Cell-root_1ruFk",
  "popoverIcon": "Cell-popoverIcon_3R4-Q"
};
function renderPopoverIcon({
  popoverIcon
}) {
  if (Array.isArray(popoverIcon)) {
    return popoverIcon.map(ppvrcn => /*#__PURE__*/React.cloneElement(ppvrcn, {
      className: styles.popoverIcon
    }));
  }
  if (popoverIcon && /*#__PURE__*/React.isValidElement(popoverIcon)) {
    return /*#__PURE__*/React.cloneElement(popoverIcon, {
      className: styles.popoverIcon
    });
  }
  return null;
}
function Cell(props) {
  const {
    children,
    popoverIcon,
    className,
    ...extraProps
  } = props;
  const rootClasses = clsx(styles.root, className);
  return /*#__PURE__*/_jsxs(Widget, {
    widgetFluidHeight: true,
    tagName: "span",
    flex: true,
    flexAlignItemsCenter: true,
    paddingLeft: "small",
    paddingRight: popoverIcon ? null : 'small',
    className: rootClasses,
    ...extraProps,
    children: [children, renderPopoverIcon(props)]
  });
}
export default Cell;